import { Input, Modal, Select, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import {
  Customers as GetCusts,
  get_customers
} from "../../actions/admin/Action";
import Search from "../../assets/search.svg";
import Table from "../../common/Table";
import { apis } from "../../config/apis";
import endpoint from "../../config/endpoint";

const AdminsTable = () => {
  const dispatch = useDispatch();
  const customers = useSelector((state) => state?.admin?.customers?.data);
  const customersLoading = useSelector((state) => state?.admin?.customers?.loading);
  const [modal, setModal] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [isAct, setIsAct] = useState({});
  const [id, setId] = useState("");
  const inputRef = useRef();
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      permissions: []
    },
    validationSchema: Yup.object().shape({
      name: Yup.string(),
      email: Yup.string().email("Enter valid email").required("Email is required"),
      password: Yup.string().required("Password is required"),
      confirmPassword: Yup.string()
        .required("Confirm Password is required")
        .oneOf([Yup.ref("password"), null], "Passwords must match"),
    }),
    onSubmit: (vals) => {
      let values = { ...vals }
      delete values.confirmPassword;
      if (isAct?.id) {
        delete values.password;
        endpoint.post(apis.admin.admin_update, values).then(() => {
          setModal(false)
          setIsAct({})
          dispatch(
            get_customers({
              email: localStorage.getItem("email"),
              isAdmin: true
            })
          );
          toast.success("Updated admin successfully.")
        }).catch(() => {
          toast.error("Failed to update admin.")
        })
      } else {
        endpoint.post(apis.admin.admins, values).then(() => {
          setModal(false)
          dispatch(
            get_customers({
              email: localStorage.getItem("email"),
              isAdmin: true
            })
          );
          toast.success("Created admin successfully.")
        }).catch(() => {
          toast.error("Failed to create admin.")
        })
      }
    }
  })
  useEffect(() => {
    dispatch(
      get_customers({
        email: localStorage.getItem("email"),
        isAdmin: true
      })
    );
    // eslint-disable-next-line
  }, []);

  const callEnable = (isEnable, id) => {
    endpoint.post(isEnable ? apis.admin.admin_disable : apis.admin.admin_enable, {}, {
      params: {
        id
      }
    }).then((res) => {
      toast.success(res.data?.message)
      setId("")
      setConfirm(false)
      dispatch(
        get_customers({
          email: localStorage.getItem("email"),
          isAdmin: true
        })
      );
    }).catch(() => {
      toast.error("Failed to update status.")
    })
  }

  const callDelete = (id) => {
    endpoint.post(apis.admin.admin_delete, {
        id: id,
        admin: true,
        email: localStorage.getItem("email"),
    }).then((res) => {
      toast.success(res.data?.message)
      setIsAct({})
      setConfirm(false)
      dispatch(
        get_customers({
          email: localStorage.getItem("email"),
          isAdmin: true
        })
      );
    }).catch(() => {
      toast.error("Failed to delete.")
    })
  }

  const columns = [
    {
      header: "Name",
      width: 20,
      accessor: "name",
    },
    {
      header: "Email ID",
      width: 20,
      accessor: "email",
    },
    {
      header: "Permissions",
      width: 25,
      accessor: "permissions",
      cell: (rec) => {
        return rec?.permissions?.join(", ")
      }
    },
    {
      header: "Account Status",
      width: 10,
      accessor: "status",
    },
    {
      header: "Action",
      width: 20,
      accessor: "id",
      cell: (rec) => {
        return <Space>
          {localStorage.getItem("email") === "it_support@omni-united.com" && <>
            <button
              className="enable-btn icon"
              onClick={() => {
                setIsAct(rec)
                formik.setValues({
                  ...rec,
                  password: "xxx",
                  confirmPassword: "xxx"
                })
                setModal(true)
              }}
            >
              <EditOutlined size={20} />
            </button>
            <button
              className="enable-btn icon"
              onClick={() => {
                setIsAct(rec)
                setConfirm(true)
              }}
            >
              <DeleteOutlined size={20} />
            </button>
          </>
          }
          <button
            className="enable-btn"
            onClick={() => {
              if (rec?.status === "active") {
                setId(rec?.id)
                setConfirm(true)
              } else {
                callEnable(rec?.status === "active", rec?.id)
              }

            }}>{rec?.status === "active" ? "Disable" : "Enable"}</button>
        </Space>
      }
    },
  ];

  return (
    <div>
      <Modal title={`${isAct?.id ? "Edit" : "Add"} Admin`} visible={modal} onCancel={() => {
        setModal(false)
        setIsAct({})
        formik.resetForm()
      }} footer={null}>
        <form onSubmit={formik.handleSubmit} className="marketing-form">
          <div className="mb1">
            <label>Name</label>
            <Input onChange={formik.handleChange} name="name" value={formik.values.name} />
            {formik?.errors?.name &&
              formik?.touched?.name && (
                <div className="error-text mtHalf">{formik?.errors?.name}</div>
              )}
          </div>
          <div className="mb1">
            <label>Email</label>
            <Input onChange={formik.handleChange} name="email" value={formik.values.email} />
            {formik?.errors?.email &&
              formik?.touched?.email && (
                <div className="error-text mtHalf">{formik?.errors?.email}</div>
              )}
          </div>
          {isAct?.id ? null : <>
            <div className="mb1">
              <label>Password</label>
              <Input.Password onChange={formik.handleChange} name="password" value={formik.values.password} />
              {formik?.errors?.password &&
                formik?.touched?.password && (
                  <div className="error-text mtHalf">{formik?.errors?.password}</div>
                )}
            </div>
            <div className="mb1">
              <label>Confirm Password</label>
              <Input.Password onChange={formik.handleChange} name="confirmPassword" value={formik.values.confirmPassword} />
              {formik?.errors?.confirmPassword &&
                formik?.touched?.confirmPassword && (
                  <div className="error-text mtHalf">{formik?.errors?.confirmPassword}</div>
                )}
            </div>
          </>}
          <div className="mb1">
            <label>Permissions</label>
            <Select
              className="w100"
              options={[{
                label: "Customers",
                value: "customers"
              }, {
                label: "Admins",
                value: "admins"
              }, {
                label: "Manage Products",
                value: "products"
              }, {
                label: "Marketing",
                value: "marketing"
              }, {
                label: "Sales Orders",
                value: "orders"
              }]}
              onChange={(val) => {
                formik.setFieldValue("permissions", val)
              }}
              name="permissions"
              mode="multiple"
              value={formik.values.permissions}
            />
            {formik?.errors?.permissions &&
              formik?.touched?.permissions && (
                <div className="error-text mtHalf">{formik?.errors?.permissions}</div>
              )}
          </div>

          <div>
            <button className="cancel-btn mr1" type="button" onClick={() => {
              setModal(false)
              formik.resetForm()
            }}>{"Close"}</button>
            <button className="primary-btn" type="submit">{"Save"}</button>
          </div>
        </form>
      </Modal>
      <Modal footer={[<button className="cancel-btn mr1" type="button" onClick={() => {
        setConfirm(false)
      }}>{"Close"}</button>,
      <button className="primary-btn" onClick={() => {
        if (isAct?.id) {
          callDelete(isAct?.id)
        } else
          callEnable(true, id)
      }} >{isAct?.id ? "Delete" : "Disable"}</button>]} title={`Are you sure you want to ${isAct?.id ? "delete" : "disable"} ?`} visible={confirm} onCancel={() => {
        setConfirm(false)
      }} />
      <div className="table-head flex-between">
        <div className="v-center">
          <div className="input">
            <img src={Search} alt="search" />
            <input placeholder={"Search by Name / Email / Mobile"} onChange={(e) => {
              if (inputRef.current) {
                clearTimeout(inputRef.current)
              }
              inputRef.current = setTimeout(() => {
                dispatch({
                  type: GetCusts.CHANGED,
                  filter: true,
                  searchKey: e.target.value
                })
              }, 200)
            }} />
          </div>
          {/* <div className="ml2">
            <SelectComponent options={[]} />
          </div>
          <div className="ml2">
            <SelectComponent options={[]} />
          </div> */}
        </div>
        <div className="v-center">
          {/* <div>
            <button className="export-to-xl">Export to excel</button>
          </div>
          <div>
            <button className="ml2 primary-btn">Collect New KYC</button>
          </div> */}
          <div>
            <button
              className="ml2 primary-btn"
              onClick={() => {
                setModal(true)
              }}
            >
              + Add New
            </button>
          </div>
        </div>
      </div>
      <div>
        <Table
          loading={customersLoading}
          columns={columns}
          data={Array.isArray(customers) ? customers?.sort((a, b) => a.name?.localeCompare(b.name)) : []}
        />
      </div>
    </div>
  );
};

export default AdminsTable;
